import React from 'react';
import {AuthenticatedTemplate, UnauthenticatedTemplate, useAccount, useMsal} from "@azure/msal-react";
import {loginRequest} from "../../authConfig";
import {Link, useLocation} from "react-router-dom";

export function JobView() {
    const {instance} = useMsal();
    const account = useAccount();

    const loginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };

    const job = useLocation().state

    function DisplayVehicleInfo(props) {
        const numberVehicles = parseInt(job.enquiry.numberOfVehicles);
        const returnInfo = [];


        if (numberVehicles === 0) {
            returnInfo.push(
                <div>
                    No information about vehicles was provided.
                </div>
            )
        } else {
            for (const key in job.vehicles) {
                if (job.vehicles.hasOwnProperty(key)) {
                    returnInfo.push(
                        <div>
                            <div className="list-section m-3">
                                <h4 className="list-section-header">Vehicle #{job.vehicles[key].id} </h4>


                                <Link to={"/management/jobs/view/vehicle-timeline"}
                                      state={{vehicle: job.vehicles[key], job: job}}>
                                    <button className="btn btn-primary list-section-btn float-right">View Timeline
                                    </button>
                                </Link>

                                <p className="list-section-date-time text-secondary"> Licence
                                    plate: {job.vehicles[key].licencePlate}</p>
                                <p className="list-section-date-time text-secondary pt-4"> {job.vehicles[key].make}, {job.vehicles[key].model} </p>
                                <br/> <br/>
                            </div>
                        </div>
                    )
                }
            }
        }

        return returnInfo;
    }

    return (
        <div>
            <UnauthenticatedTemplate>
                <h5 className="no-access-message"> Sorry, you don't have access to this page! </h5>
            </UnauthenticatedTemplate>

            <AuthenticatedTemplate>

                <div className="page-title-sh26">
                    <h1>Job #{job.id} Details</h1>
                    <h5>Job overview for {job.name}</h5>
                </div>
                <hr/>

                <Link to={"/management/jobs/view/timeline"} state={job}>
                    <button className="btn btn-secondary float-end">View job timeline &gt;&gt;</button>
                </Link>
                <br/>
                <div className="page-break"></div>
                <div className="list-section">
                    <h3> Customer Details </h3>
                    <hr/>
                    <hr/>
                    <p>Company name: {job.enquiry.companyName} </p>
                    <p>Customer name: {job.enquiry.customerName} </p>
                    <p>Customer email: {job.enquiry.customerEmail} </p>
                    <p>Customer phone number: {job.enquiry.phoneNumber} </p>
                    <p>Message: {job.enquiry.message} </p>

                    <br/>

                </div>


                <div className="page-break"></div>

                <div className="list-section">
                    <h3> Customer Vehicles </h3>
                    <hr/>

                    <DisplayVehicleInfo/>

                </div>


                <div className="page-break"></div>
            </AuthenticatedTemplate>
        </div>
    );
}
